var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendarDarkgrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#383C40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.222 11.438c.382 0 .695.309.695.687 0 .378-.313.688-.695.688-.382 0-.694-.31-.694-.688 0-.378.312-.688.694-.688zm5.556 0c.382 0 .694.309.694.687 0 .378-.312.688-.694.688H10c-.382 0-.694-.31-.694-.688 0-.378.312-.688.694-.688zm1.389 3.437H5.833c-.382 0-.694-.309-.694-.688v-4.124h9.722v4.124c0 .38-.312.688-.694.688M5.833 5.25h.695v.688c0 .378.312.687.694.687.382 0 .695-.31.695-.688V5.25h4.166v.688c0 .378.313.687.695.687.382 0 .694-.31.694-.688V5.25h.695c.382 0 .694.309.694.688v2.75H5.14v-2.75c0-.38.312-.688.694-.688m8.334-1.375h-.695v-.688c0-.378-.312-.687-.694-.687-.382 0-.695.31-.695.688v.687H7.917v-.688c0-.378-.313-.687-.695-.687-.382 0-.694.31-.694.688v.687h-.695c-1.148 0-2.083.925-2.083 2.063v8.25c0 1.137.935 2.062 2.083 2.062h8.334c1.148 0 2.083-.925 2.083-2.063v-8.25c0-1.137-.935-2.062-2.083-2.062",
    transform: "translate(-49.000000, -967.000000) translate(49.000000, 967.500000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarDarkgrey);
export default __webpack_public_path__ + "static/media/icon-calendar--darkgrey.21f3db42a508c66ad40ac46b096604fc.svg";
export { ForwardRef as ReactComponent };